var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLateNight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.29,137.37h79.2s-7-12.75-27.39-10.89c-19.47,1.77-20.46-6.27-30.36-7.26S50.59,125.82,47.29,137.37Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.78,99.55H275s-12.84-23.37-50.23-20c-35.71,3.25-37.53-11.5-55.68-13.32S135.83,78.37,129.78,99.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.62,193.27l36.22-35.21S478.26,196,476,195.22,473.62,193.27,473.62,193.27Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "511.19 61.9 513.71 63.22 511.24 64.64 509.92 67.16 508.5 64.69 505.98 63.37 508.45 61.95 509.77 59.42 511.19 61.9",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "476.97 191.87 479.5 193.19 477.02 194.61 475.7 197.13 474.28 194.66 471.76 193.34 474.23 191.92 475.56 189.4 476.97 191.87",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.15 156.66 343.68 157.99 341.2 159.4 339.88 161.93 338.47 159.45 335.94 158.13 338.42 156.72 339.74 154.19 341.15 156.66",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.75 170.45 237.28 171.77 234.8 173.19 233.48 175.71 232.06 173.24 229.54 171.91 232.01 170.5 233.34 167.97 234.75 170.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.03 196.44 324.3 197.1 323.06 197.81 322.4 199.07 321.69 197.83 320.43 197.17 321.66 196.46 322.32 195.2 323.03 196.44",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.55 68.4 434.81 69.06 433.57 69.77 432.91 71.03 432.2 69.8 430.94 69.13 432.18 68.43 432.84 67.16 433.55 68.4",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "673.2 145.05 674.47 145.72 673.23 146.42 672.57 147.69 671.86 146.45 670.6 145.79 671.84 145.08 672.5 143.82 673.2 145.05",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "433.55 213.88 434.81 214.55 433.57 215.25 432.91 216.52 432.2 215.28 430.94 214.62 432.18 213.91 432.84 212.65 433.55 213.88",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.67,221.3h79.2s-7-12.74-27.39-10.89c-19.47,1.77-20.46-6.27-30.36-7.26S369,209.75,365.67,221.3Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.75,88.93H655S648,76.18,627.56,78c-19.47,1.77-20.46-6.28-30.36-7.27S579.05,77.38,575.75,88.93Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M571,179.19H683.43s-9.95-18.1-38.89-15.47c-27.65,2.52-29-8.9-43.11-10.31S575.66,162.79,571,179.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "643.82 199.45 627.57 234.99 632.42 235.19 618.65 263.43 625.88 263.43 614.6 288.52 677.68 288.52 663.79 263.43 670.44 263.12 657.13 234.89 662.05 234.58 643.82 199.45",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.3,238.91c.1,0,0,21.46-.31,47.92s-.68,48-.67,47.92c0-1.4,0-21.45.31-47.92S646.2,238.91,646.3,238.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.68,248.05a62.29,62.29,0,0,1-3.92,5.38,61.74,61.74,0,0,1-4.21,5.17,60.7,60.7,0,0,1,3.92-5.39A60.18,60.18,0,0,1,654.68,248.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.13,257.84a31.85,31.85,0,0,1-3.87-2.79,30.63,30.63,0,0,1-3.65-3.07,63.9,63.9,0,0,1,7.52,5.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.67,275.28a7.86,7.86,0,0,1-1.3-1c-.78-.65-1.84-1.55-3-2.53s-2.3-1.84-3.09-2.47A7.91,7.91,0,0,1,637,268.2a6.69,6.69,0,0,1,1.41.86c.84.57,2,1.41,3.17,2.39s2.25,1.92,3,2.62A6.47,6.47,0,0,1,645.67,275.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M654.69,264.5a69.85,69.85,0,0,1-4.3,5.64,67.07,67.07,0,0,1-4.58,5.41,67.13,67.13,0,0,1,4.3-5.64A69.28,69.28,0,0,1,654.69,264.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "563.05 210.59 555.94 226.14 558.06 226.23 552.03 238.59 555.2 238.59 550.26 249.56 577.86 249.56 571.79 238.59 574.7 238.45 568.87 226.1 571.03 225.96 563.05 210.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.13,227.86s0,9.39-.13,21-.3,21-.3,21c0-.61,0-9.38.14-21S564.09,227.86,564.13,227.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.8,231.86a25.18,25.18,0,0,1-1.72,2.35,23.93,23.93,0,0,1-1.84,2.26s.74-1.08,1.72-2.35A25.93,25.93,0,0,1,567.8,231.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M564.06,236.14a12.91,12.91,0,0,1-1.69-1.22,14.63,14.63,0,0,1-1.6-1.34,12.91,12.91,0,0,1,1.69,1.22A14.63,14.63,0,0,1,564.06,236.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.86,243.77a3.28,3.28,0,0,1-.57-.44L562,242.22c-.52-.43-1-.81-1.35-1.08a2.75,2.75,0,0,1-.55-.47,3.85,3.85,0,0,1,.61.38c.37.25.86.62,1.39,1s1,.84,1.31,1.14A3,3,0,0,1,563.86,243.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.81,239.06s-.81,1.13-1.88,2.46-2,2.4-2,2.37.81-1.13,1.88-2.47A27.25,27.25,0,0,1,567.81,239.06Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M701.42,463c0,.15-146.16.26-326.4.26S48.58,463.18,48.58,463s146.13-.26,326.44-.26S701.42,462.89,701.42,463Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Mountains--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M719.35,289.92l-1.86-.78-5.43-2.34c-4.78-2-11.82-5.09-21-8.74a321.13,321.13,0,0,0-34-11.56c-13.51-3.64-29.37-6.62-47-6.2s-36.75,5.12-55.69,13.56-37.82,20.31-56.87,33.75c-9.55,6.71-19.23,13.73-29.28,20.69s-20.48,13.84-31.56,20.09S413.83,360.45,401,363.54a67.83,67.83,0,0,1-19.72,1.95,60.68,60.68,0,0,1-9.92-1.52,64.94,64.94,0,0,1-9.55-3.3,101.05,101.05,0,0,1-17.41-10.05c-5.46-3.82-10.65-7.91-15.85-11.92L297.92,315,240,270.12C230.76,263,221.77,256,212.74,249.6a254.28,254.28,0,0,0-27.22-17.06,142.71,142.71,0,0,0-27.67-11.44,100.77,100.77,0,0,0-27.29-4,109.66,109.66,0,0,0-24.93,2.8l-5.69,1.43L94.5,223c-1.8.52-3.49,1.26-5.19,1.87s-3.38,1.24-5,2A177.26,177.26,0,0,0,53,244.35c-8.09,5.65-14,10.58-18,13.89l-4.45,3.89-1.53,1.31,1.49-1.35L35,258.17c4-3.34,9.85-8.29,17.94-14a175.58,175.58,0,0,1,31.33-17.61c1.59-.75,3.27-1.34,5-2s3.4-1.36,5.2-1.88L99.86,221l5.7-1.44a109.08,109.08,0,0,1,25-2.84,101,101,0,0,1,27.38,4,142.93,142.93,0,0,1,27.76,11.44A256.68,256.68,0,0,1,213,249.25c9,6.39,18,13.38,27.27,20.51l57.95,44.83,30.65,23.72c5.19,4,10.39,8.1,15.83,11.91a99.85,99.85,0,0,0,17.32,10,64.37,64.37,0,0,0,9.48,3.27,58.55,58.55,0,0,0,9.83,1.51,67.31,67.31,0,0,0,19.58-1.93c12.75-3.07,24.44-8.87,35.47-15.09s21.48-13.12,31.52-20.06,19.73-14,29.29-20.67c19.07-13.44,37.92-25.4,57-33.76S592.29,260.34,610,260s33.6,2.61,47.11,6.28a320.19,320.19,0,0,1,34,11.64c9.17,3.68,16.19,6.76,21,8.83l5.41,2.38C718.73,289.63,719.35,289.92,719.35,289.92Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M219,445.37c-.64-2.54,1-5.07,2.91-6.9s4.1-3.45,5.08-5.88c1.59-3.92-.49-9,2.21-12.3,1.59-1.92,4.41-2.55,5.82-4.61a10.33,10.33,0,0,0,1.28-3.68,37.56,37.56,0,0,1,9.41-17.37A32.44,32.44,0,0,1,242,411.41c-1.09,2-2.43,4.06-2.81,6.36-.6,3.74,1.46,7.6.52,11.27-1.07,4.19-5.8,7-6.05,11.3-.21,3.66,3,6.88,2.7,10.53a9.86,9.86,0,0,1-1.65,4.33c-2.86,4.68-7,7.89-13.32,7.75l-7.71.23Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219,445.37c-.64-2.54,1-5.07,2.91-6.9s4.1-3.45,5.08-5.88c1.59-3.92-.49-9,2.21-12.3,1.59-1.92,4.41-2.55,5.82-4.61a10.33,10.33,0,0,0,1.28-3.68,37.56,37.56,0,0,1,9.41-17.37A32.44,32.44,0,0,1,242,411.41c-1.09,2-2.43,4.06-2.81,6.36-.6,3.74,1.46,7.6.52,11.27-1.07,4.19-5.8,7-6.05,11.3-.21,3.66,3,6.88,2.7,10.53a9.86,9.86,0,0,1-1.65,4.33c-2.86,4.68-7,7.89-13.32,7.75l-7.71.23Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M212.05,463.23a6.14,6.14,0,0,1-2.12-.05,13.52,13.52,0,0,1-2.51-.65,10.78,10.78,0,0,1-3.08-1.71,4.28,4.28,0,0,1-1.26-1.7,7.92,7.92,0,0,1-.35-2.31,23.86,23.86,0,0,0-.17-2.49,6.7,6.7,0,0,0-.93-2.49c-.9-1.6-2.4-3.12-2.87-5.29a17.24,17.24,0,0,1,.25-6.76c.37-2.31.73-4.83-.14-7.24s-2.49-4.6-3.32-7.32-.42-5.7-.58-8.62a11.61,11.61,0,0,0-1-4.28c-.62-1.37-1.48-2.66-2.14-4.1-1.36-2.91-1.58-6.21-1.93-9.43-.18-1.63-.35-3.27-.53-4.93a23.62,23.62,0,0,0-.83-4.94,42.83,42.83,0,0,0-1.81-4.78,15.05,15.05,0,0,1-.88-2.5,23.93,23.93,0,0,1-.24-2.65,30.7,30.7,0,0,1,.24-5.33c.22-1.78.55-3.54.75-5.32l0-.31,0-.36.31.16a12,12,0,0,1,4.13,3.53,18.62,18.62,0,0,1,2.52,4.71A57.93,57.93,0,0,1,196,386.18a27.31,27.31,0,0,0,3.11,9.34c.84,1.38,1.85,2.64,2.74,4a11,11,0,0,1,1.89,4.41c.44,3.26-1.38,6.11-1,9a10.14,10.14,0,0,0,1.38,4c.7,1.24,1.51,2.38,2.29,3.54a22.71,22.71,0,0,1,2,3.57,11.28,11.28,0,0,1,.92,3.86c.17,2.61-.21,5.07,0,7.4a16.85,16.85,0,0,0,1.87,6.34c.92,1.91,1.94,3.63,2.8,5.3a25.9,25.9,0,0,1,1.16,2.46,12,12,0,0,1,.66,2.44,15.12,15.12,0,0,1,0,4.4,11.13,11.13,0,0,1-2.23,5.6,7.06,7.06,0,0,1-.63.67,3.53,3.53,0,0,1-.51.43c-.29.21-.44.3-.44.3a10.75,10.75,0,0,0,1.5-1.46,11.18,11.18,0,0,0,2.12-5.57,15.46,15.46,0,0,0-.07-4.33,12.06,12.06,0,0,0-.67-2.39c-.32-.79-.73-1.6-1.16-2.43-.87-1.65-1.91-3.36-2.85-5.28a17.35,17.35,0,0,1-1.93-6.46c-.19-2.37.18-4.85,0-7.39a10.79,10.79,0,0,0-.91-3.74,22,22,0,0,0-2-3.49c-.78-1.15-1.6-2.3-2.31-3.56A10.33,10.33,0,0,1,202.3,413c-.36-3.08,1.44-5.95,1-9a10.44,10.44,0,0,0-1.83-4.21c-.87-1.32-1.89-2.58-2.75-4a27.72,27.72,0,0,1-3.19-9.5,57.52,57.52,0,0,0-2.33-10,18.27,18.27,0,0,0-2.45-4.59,11.53,11.53,0,0,0-4-3.38l.36-.2c0,.1,0,.21,0,.31-.2,1.81-.54,3.57-.75,5.33a30.82,30.82,0,0,0-.24,5.25c0,.86.1,1.76.23,2.57a14.4,14.4,0,0,0,.85,2.41,44.12,44.12,0,0,1,1.83,4.84,25,25,0,0,1,.84,5c.17,1.66.35,3.31.52,4.94.35,3.24.57,6.48,1.87,9.29.64,1.4,1.5,2.69,2.13,4.1a11.81,11.81,0,0,1,1,4.45c.15,3-.25,5.88.54,8.52s2.45,4.82,3.29,7.32.5,5.12.12,7.42a17.46,17.46,0,0,0-.29,6.63c.44,2.07,1.9,3.58,2.81,5.22a7.33,7.33,0,0,1,.95,2.59,22.26,22.26,0,0,1,.14,2.52,7.92,7.92,0,0,0,.32,2.24,4.11,4.11,0,0,0,1.19,1.63,10.38,10.38,0,0,0,3,1.72,13.44,13.44,0,0,0,2.46.69,12.09,12.09,0,0,0,1.57.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.21,372.28a2.46,2.46,0,0,1,.07.24c0,.18.1.41.17.69.14.61.32,1.53.6,2.67s1,2.44,1.58,4,1.23,3.42,1.8,5.48,1.09,4.34,1.62,6.79a28.62,28.62,0,0,0,2.42,7.54c.63,1.26,1.33,2.53,1.89,3.92a18.28,18.28,0,0,1,1.08,4.43,92.12,92.12,0,0,0,1.61,9.33l4.26,17.84,3.57,14.55,2.37,9.82.61,2.67c.06.29.11.52.15.7a1.12,1.12,0,0,1,0,.24s0-.07-.09-.23-.11-.41-.19-.68c-.17-.65-.41-1.53-.71-2.66-.61-2.35-1.46-5.68-2.52-9.78s-2.29-9.06-3.67-14.52-2.78-11.51-4.3-17.84a90.58,90.58,0,0,1-1.61-9.37,17.46,17.46,0,0,0-1-4.33c-.54-1.35-1.23-2.62-1.86-3.88a28.69,28.69,0,0,1-2.41-7.66c-.52-2.46-1-4.74-1.56-6.79a57,57,0,0,0-1.72-5.47c-.56-1.59-1.23-2.91-1.5-4.09s-.4-2.08-.52-2.7c0-.28-.09-.52-.12-.7A.94.94,0,0,1,188.21,372.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.69,463.25c-5-3-6.41-12.11-4.28-17.57s5.83-10.43,6.43-16.26c.46-4.48-1-9.08.09-13.46,1.44-5.9,7.24-10.45,7.21-16.52,0-3.41-1.94-6.63-1.77-10,.22-4.17,3.44-7.47,5.45-11.14,3.07-5.62,3.31-12.28,4.38-18.59s3.52-13.06,9.14-16.13c.8,5.37,2.19,9,1.7,16.31-.17,2.61-3.23,7.59-3.68,13.3-.26,3.42-.45,6.84-.68,10.26a32.84,32.84,0,0,1-1.67,9.82c-.93,2.38-2.41,4.54-3.1,7-1.3,4.63.35,9.66-.71,14.34-.9,4-3.67,7.39-4.26,11.42-.82,5.66,2.82,11.57.91,17-.95,2.68-3.17,4.82-3.81,7.59-.5,2.15,0,4.42-.43,6.58-.73,3.47-7.38,6.36-10.92,6.13",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.92,348.86a1.36,1.36,0,0,1,0,.3l-.12.88c-.12.77-.26,1.91-.53,3.38s-1.06,3.14-1.68,5.14-1.3,4.3-1.88,6.88-1.09,5.44-1.61,8.52a35.48,35.48,0,0,1-2.64,9.61c-.71,1.61-1.52,3.22-2.12,4.93a22,22,0,0,0-1.09,5.43,107.47,107.47,0,0,1-1.55,11.72c-1.58,7.94-3.09,15.5-4.47,22.38s-2.75,13-3.85,18.23l-2.64,12.27c-.32,1.43-.57,2.54-.74,3.34-.09.36-.15.64-.21.86a4.44,4.44,0,0,0-.08.52,3,3,0,0,1,0-.53c0-.22.1-.51.16-.87.16-.8.37-1.92.65-3.35.59-2.94,1.44-7.14,2.49-12.31s2.33-11.39,3.74-18.25,2.86-14.44,4.44-22.37a111.8,111.8,0,0,0,1.54-11.68,22.7,22.7,0,0,1,1.13-5.55c.63-1.75,1.44-3.36,2.16-4.95a35.7,35.7,0,0,0,2.64-9.51c.54-3.06,1.06-5.93,1.67-8.51s1.29-4.9,2-6.9,1.44-3.65,1.75-5.09.47-2.59.62-3.36c.07-.36.13-.65.17-.87A1.07,1.07,0,0,1,235.92,348.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.84,432c-1.45,2.09-4.29,1.4-5.6.13a10.66,10.66,0,0,1-2.38-4.87c-1.15-4-2.32-8.23-1.46-12.32a6.83,6.83,0,0,1,1.58-3.34,3.55,3.55,0,0,1,3.38-1.13c1.43.38,2.32,1.78,3,3.11a29.21,29.21,0,0,1,2.9,12.59,10.1,10.1,0,0,1-1.38,5.83",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M684.84,432c-1.45,2.09-4.29,1.4-5.6.13a10.66,10.66,0,0,1-2.38-4.87c-1.15-4-2.32-8.23-1.46-12.32a6.83,6.83,0,0,1,1.58-3.34,3.55,3.55,0,0,1,3.38-1.13c1.43.38,2.32,1.78,3,3.11a29.21,29.21,0,0,1,2.9,12.59,10.1,10.1,0,0,1-1.38,5.83"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M679.38,442.51a12.62,12.62,0,0,0-7.84-.95,6.48,6.48,0,0,0-3.87,1.73,2.78,2.78,0,0,0,0,3.86,3.68,3.68,0,0,0,2.44.62c2.07,0,4.37-.39,6,.86.94.71,1.57,1.89,2.7,2.24a2.68,2.68,0,0,0,2.94-1.3,4.62,4.62,0,0,0,.33-3.37A5.15,5.15,0,0,0,679.38,442.51Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.85,435a7.54,7.54,0,0,1-1.18-7,13.35,13.35,0,0,1,4.13-6,22.12,22.12,0,0,1,7.39-4.36,7.81,7.81,0,0,1,3.33-.57,3.51,3.51,0,0,1,2.79,1.69c.78,1.48,0,3.28-.77,4.75a56.84,56.84,0,0,1-4.86,7.4,13.23,13.23,0,0,1-5.34,4.58c-2.22.84-4.53.74-5.7-.79",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.94,463a5.26,5.26,0,0,1-.13-.94c-.07-.69-.15-1.56-.25-2.59a37.53,37.53,0,0,0-.58-3.78,28.31,28.31,0,0,0-1.38-4.47,16.38,16.38,0,0,0-2.28-4.05,8.6,8.6,0,0,0-2.89-2.4A8.06,8.06,0,0,0,675,444a4.46,4.46,0,0,1-.94-.13,4.47,4.47,0,0,1,1,0,7.37,7.37,0,0,1,2.53.66A8.66,8.66,0,0,1,680.6,447,15.87,15.87,0,0,1,683,451.1a27.23,27.23,0,0,1,1.37,4.54,30.3,30.3,0,0,1,.5,3.84c.09,1.1.12,2,.13,2.6A3.7,3.7,0,0,1,684.94,463Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.77,461.39a1.25,1.25,0,0,1,0-.44v-1.26c0-1.09,0-2.66,0-4.61-.1-3.89-.43-9.27-1.08-15.18s-1.52-11.22-2.31-15c-.18-1-.37-1.82-.55-2.57s-.31-1.41-.45-1.93-.22-.9-.29-1.22a1.72,1.72,0,0,1-.08-.44,1.81,1.81,0,0,1,.15.42c.1.31.22.71.37,1.2s.33,1.17.51,1.92.41,1.61.61,2.56A144,144,0,0,1,684,439.86c.64,5.92.94,11.31,1,15.22,0,1.95,0,3.53-.07,4.62,0,.51,0,.92-.07,1.25A2.19,2.19,0,0,1,684.77,461.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M684.74,451a8.22,8.22,0,0,1,0-1.31c0-.84.16-2.06.4-3.55a49.86,49.86,0,0,1,3.32-11.31,32.8,32.8,0,0,1,6.36-9.9,18.15,18.15,0,0,1,1.49-1.39L697,423l.58-.4a6.42,6.42,0,0,1,1.11-.7,37,37,0,0,0-3.62,3.22,34.36,34.36,0,0,0-6.2,9.87,48.82,48.82,0,0,0-2.18,6.07c-.57,1.9-.94,3.65-1.23,5.12s-.43,2.69-.52,3.52A8.31,8.31,0,0,1,684.74,451Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.3,413a9.68,9.68,0,0,1,6.38,4.08,17,17,0,0,1,2.76,7.21c.83,5-.51,10.57-2.35,15.25-5-2.37-7.74-8.25-8.92-11.33-1.86-4.85-2.27-14.75,2.13-15.21",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.54,446.49a8.23,8.23,0,0,1-.2-8.28,10.92,10.92,0,0,1,6.72-5.15,4.6,4.6,0,0,1,3.88.27,3.53,3.53,0,0,1,1.28,3.34,7.12,7.12,0,0,1-1.59,3.36c-2.63,3.4-5.8,6.2-10.09,6.46",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.26,462.18a3.71,3.71,0,0,1-.17-1.05c-.07-.67-.15-1.64-.22-2.85a35.42,35.42,0,0,1,.58-9.47,17.69,17.69,0,0,1,4.3-8.43,12,12,0,0,1,2.23-1.84,3.3,3.3,0,0,1,1-.47,24.52,24.52,0,0,0-2.89,2.58,18.58,18.58,0,0,0-4,8.28,41.07,41.07,0,0,0-.73,9.33A32.09,32.09,0,0,1,125.26,462.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.48,420.49a11.54,11.54,0,0,1,.63,1.62c.38,1.06.9,2.59,1.52,4.49,1.24,3.81,2.87,9.09,4.53,15s3,11.23,4,15.13c.46,1.94.82,3.52,1,4.62a9.78,9.78,0,0,1,.3,1.71,10,10,0,0,1-.52-1.66c-.31-1.18-.72-2.72-1.22-4.58-1-3.86-2.45-9.2-4.1-15.07s-3.23-11.17-4.37-15l-1.35-4.54A9.08,9.08,0,0,1,113.48,420.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.81,451.2a19.29,19.29,0,0,0-13.79-11c-1.53-.29-3.42-.25-4.27,1.05s-.12,3.06.8,4.32a16.47,16.47,0,0,0,17.27,6",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.7,444.61a3.42,3.42,0,0,1,1,.1,8.49,8.49,0,0,1,1.16.25,13.64,13.64,0,0,1,1.51.45,20.68,20.68,0,0,1,3.71,1.73,21.62,21.62,0,0,1,7.17,6.94,20,20,0,0,1,1.85,3.66,14.49,14.49,0,0,1,.5,1.49,8,8,0,0,1,.29,1.15,3.39,3.39,0,0,1,.13,1c-.11,0-.38-1.39-1.29-3.49a22.35,22.35,0,0,0-1.91-3.52,22.83,22.83,0,0,0-7-6.78,22.3,22.3,0,0,0-3.58-1.81C109.1,445,107.68,444.72,107.7,444.61Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "576 65.77 578.53 67.09 576.05 68.51 574.73 71.03 573.32 68.56 570.79 67.23 573.27 65.82 574.59 63.29 576 65.77",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "273.16 200.01 275.69 201.34 273.21 202.75 271.89 205.28 270.48 202.8 267.95 201.48 270.43 200.06 271.75 197.54 273.16 200.01",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "671.86 110.02 674.38 111.34 671.91 112.75 670.59 115.28 669.17 112.8 666.64 111.48 669.12 110.07 670.44 107.54 671.86 110.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.05 113.89 499.58 115.21 497.11 116.62 495.78 119.15 494.37 116.67 491.84 115.35 494.32 113.94 495.64 111.41 497.05 113.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.97 117.85 326.23 118.52 324.99 119.22 324.33 120.49 323.62 119.25 322.36 118.59 323.6 117.88 324.26 116.62 324.97 117.85",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "239.88 115.92 241.15 116.58 239.91 117.29 239.25 118.55 238.54 117.31 237.28 116.65 238.51 115.94 239.18 114.68 239.88 115.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "366.21 64.53 367.48 65.19 366.24 65.9 365.58 67.16 364.87 65.93 363.61 65.27 364.84 64.56 365.5 63.29 366.21 64.53",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "588.49 129.02 589.76 129.68 588.52 130.38 587.86 131.65 587.15 130.41 585.89 129.75 587.13 129.04 587.79 127.78 588.49 129.02",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "375.71 187.69 376.97 188.35 375.73 189.06 375.07 190.32 374.37 189.08 373.1 188.42 374.34 187.72 375 186.45 375.71 187.69",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "531.67 197.43 532.94 198.09 531.7 198.8 531.04 200.06 530.33 198.82 529.07 198.16 530.3 197.46 530.97 196.19 531.67 197.43",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.54 80.2 94.8 80.86 93.56 81.56 92.9 82.83 92.2 81.59 90.93 80.93 92.17 80.22 92.83 78.96 93.54 80.2",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Moon--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M444.51,163.12A40.13,40.13,0,0,1,412.1,99.26a40.14,40.14,0,1,0,56.09,56.09A40,40,0,0,1,444.51,163.12Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Bonfire--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "511.21 476.81 509.32 465.16 604.84 449.62 608.5 457.81 511.21 476.81",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.52,457.4a4.76,4.76,0,0,1-1,.16l-2.88.33L593.05,459c-8.94.95-21.29,2.25-34.79,4.65-6.74,1.21-13.11,2.64-18.86,4.14s-10.89,3-15.27,4.06-8,1.77-10.44,2.13c-1.25.18-2.22.31-2.88.36a5.84,5.84,0,0,1-1,.07,4.64,4.64,0,0,1,1-.21l2.85-.49c2.48-.44,6-1.21,10.37-2.34s9.48-2.65,15.23-4.2,12.14-3,18.9-4.2c13.53-2.41,25.91-3.64,34.86-4.46,4.48-.4,8.11-.69,10.62-.87l2.89-.2A7,7,0,0,1,607.52,457.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.39,461.22a6.84,6.84,0,0,1,1.63.14c1,.14,2.55.37,4.4.66l1,.15-.94.34c-3,1.11-7.15,2.56-11.67,4.11-4.82,1.66-9.19,3.12-12.37,4.15-1.58.51-2.87.91-3.77,1.18a5.71,5.71,0,0,1-1.41.34,5.2,5.2,0,0,1,1.32-.6c.87-.34,2.14-.82,3.71-1.39,3.13-1.14,7.48-2.68,12.3-4.34,4.51-1.55,8.64-2.93,11.72-3.93l0,.49c-1.84-.35-3.33-.65-4.36-.88A6.89,6.89,0,0,1,533.39,461.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.53,452.56a2.4,2.4,0,0,1-.48.42,10,10,0,0,1-1.57.94,16.62,16.62,0,0,1-6.53,1.49c-2.85.16-6.21-.3-9.9-.43a45.32,45.32,0,0,0-11.89,1.54c-4.17,1-8.18,2-11.89,2.49a77.76,77.76,0,0,1-9.89.77c-2.83,0-5.11-.1-6.68-.24-.79-.07-1.4-.14-1.81-.2s-.63-.09-.62-.12a22.47,22.47,0,0,1,2.44,0c1.58.05,3.85.11,6.66,0a83.35,83.35,0,0,0,9.81-.92c3.68-.52,7.63-1.53,11.82-2.53a45,45,0,0,1,12.07-1.5c3.75.17,7.06.67,9.86.58a17.54,17.54,0,0,0,6.44-1.25C605.81,453.06,606.49,452.5,606.53,452.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "508.21 456.92 510.42 445.33 605.49 463.44 606.13 472.39 508.21 456.92",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.34,471.67a4.6,4.6,0,0,1-1-.19l-2.81-.68-10.33-2.6c-8.72-2.17-20.77-5.18-34.27-7.54-6.76-1.18-13.23-2-19.14-2.58s-11.26-.92-15.73-1.41-8.08-1.06-10.55-1.57c-1.23-.26-2.18-.48-2.82-.65a6,6,0,0,1-1-.28,4.46,4.46,0,0,1,1,.14l2.84.52c2.48.43,6.07.93,10.55,1.35s9.81.76,15.74,1.27,12.43,1.35,19.2,2.53c13.53,2.36,25.58,5.45,34.28,7.75,4.34,1.15,7.85,2.13,10.27,2.81l2.78.81A6.91,6.91,0,0,1,605.34,471.67Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.38,449.87a7.25,7.25,0,0,1,1.49.7c.93.48,2.26,1.21,3.9,2.12l.87.48h-1c-3.23,0-7.59-.05-12.36-.14-5.1-.09-9.71-.22-13-.34-1.67-.06-3-.13-3.95-.18a5.52,5.52,0,0,1-1.45-.17,6.5,6.5,0,0,1,1.45-.1c.94,0,2.29,0,4,0,3.33,0,7.94,0,13,.14,4.77.08,9.13.2,12.36.31l-.13.48c-1.61-1-2.91-1.75-3.79-2.32A6.93,6.93,0,0,1,534.38,449.87Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.07,466.79a2.62,2.62,0,0,1-.6.23,9.66,9.66,0,0,1-1.79.34,16.67,16.67,0,0,1-6.65-.84c-2.73-.82-5.73-2.4-9.15-3.79a45.85,45.85,0,0,0-11.71-2.63c-4.25-.49-8.36-.93-12-1.73a75.72,75.72,0,0,1-9.56-2.66c-2.67-.94-4.77-1.85-6.2-2.51-.71-.34-1.26-.61-1.63-.81s-.55-.3-.54-.33a21.14,21.14,0,0,1,2.28.89c1.46.59,3.58,1.42,6.25,2.29a84.32,84.32,0,0,0,9.53,2.51c3.63.76,7.69,1.17,12,1.66a44.45,44.45,0,0,1,11.85,2.73c3.47,1.44,6.41,3.05,9.07,3.91a17.2,17.2,0,0,0,6.48,1C605.22,467,606.05,466.72,606.07,466.79Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M598.82,462.14a6.64,6.64,0,0,1-.81-.1l-2.31-.37c-2-.33-4.9-.83-8.48-1.48-7.15-1.28-17-3.16-27.88-5.29l-27.85-5.45-8.44-1.64-2.29-.47a6.21,6.21,0,0,1-.79-.19,4.1,4.1,0,0,1,.81.09l2.31.37c2,.33,4.9.83,8.47,1.48,7.15,1.28,17,3.16,27.88,5.3l27.85,5.44,8.44,1.64,2.29.47A4.2,4.2,0,0,1,598.82,462.14Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "547.34 414.29 541.2 404.29 543.77 376.57 549.98 385.91 549.06 395.76 556 382.76 554.02 371.47 556.07 349.43 559.46 367.26 563.14 363.89 564.37 383.04 561.78 410.92 547.34 414.29",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "547.34 414.29 541.2 404.29 543.77 376.57 549.98 385.91 549.06 395.76 556 382.76 554.02 371.47 556.07 349.43 559.46 367.26 563.14 363.89 564.37 383.04 561.78 410.92 547.34 414.29",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "537.34 412.69 541.72 445.76 558.52 457.08 567.2 457.89 583.04 443.2 585.47 417.16 575.23 404.08 574.76 383.83 569.73 394.48 567.22 374.38 555.54 398.55 548.69 407 537.34 412.69",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.85 339.28 575.12 347.2 577.12 355.24 583.44 348.76 582.85 339.28",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M561.4,454.25c-1.86-3.1-3.77-6.38-3.88-10a20.83,20.83,0,0,1,1.82-7.83q2.29-6,4.82-11.93,2.4,5.79,4.82,11.59c1.27,3.05,2.56,6.35,1.77,9.55-.57,2.3-2.14,4.21-3.67,6s-3.34,3.69-5.63,3.46",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M559.45,456.47l-8.71-10.77a10.25,10.25,0,0,1-2.45-4.28c-.41-2.07.48-4.16,1.34-6.08,4.84-10.78,9.8-21.76,17.8-30.45.26,5.37,3.18,10.18,5.83,14.85s5.2,9.82,4.61,15.16c-.39,3.56-2.14,6.8-3.26,10.19a72.2,72.2,0,0,1-2.25,7,9.35,9.35,0,0,1-4.88,5.17c-3.15,1.19-6.63-.23-9.69-1.62",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M602.11,449.87a6.25,6.25,0,0,1-1.3.31l-3.57.66-11.81,2.1c-4.61.82-8.78,1.59-11.79,2.17l-3.57.69a7.24,7.24,0,0,1-1.32.2,6.39,6.39,0,0,1,1.27-.4c.83-.23,2-.51,3.54-.85,3-.68,7.16-1.5,11.78-2.32s8.8-1.5,11.84-1.95c1.52-.23,2.75-.4,3.6-.5A5.75,5.75,0,0,1,602.11,449.87Z",
    style: {
      fill: "#FF725E"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-22"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "151.45 77.8 104.85 171.8 118.77 172.33 79.28 247.02 100.02 247.02 67.67 313.39 248.51 313.39 208.69 247.02 227.77 246.19 189.61 171.53 203.72 170.7 151.45 77.8",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.33,186.84c.27,0-.1,56.76-.82,126.75S157,463,156.73,463s.1-79.35.82-149.37S159.07,186.84,159.33,186.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.5,211c.21.16-4.44,6.54-10.38,14.24S160.19,239.07,160,238.91s4.43-6.54,10.38-14.25S181.28,210.84,181.5,211Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.89,236.91c-.16.21-4.75-3.09-10.25-7.38s-9.82-7.93-9.66-8.14,4.75,3.1,10.25,7.38S159.06,236.7,158.89,236.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.66,283c-.1.1-1.39-.95-3.44-2.68s-4.87-4.11-8-6.69-6.07-4.87-8.18-6.53-3.4-2.7-3.32-2.82a18.57,18.57,0,0,1,3.73,2.27c2.21,1.53,5.2,3.74,8.38,6.33s6,5.07,7.89,6.94A19,19,0,0,1,157.66,283Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.52,254.52c.21.17-4.88,6.85-11.37,14.92S158.24,283.92,158,283.76s4.88-6.85,11.37-14.92S181.32,254.35,181.52,254.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "84.53 212.41 52.31 277.42 61.93 277.78 34.63 329.43 48.97 329.43 26.6 375.33 151.65 375.33 124.12 329.43 137.31 328.86 110.92 277.23 120.67 276.66 84.53 212.41",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90,287.82c.19,0-.06,39.25-.56,87.65s-1,87.65-1.24,87.65.07-39.24.57-87.66S89.8,287.81,90,287.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.31,304.53c.15.11-3.07,4.52-7.17,9.85s-7.56,9.56-7.71,9.44,3.07-4.52,7.18-9.85S105.16,304.42,105.31,304.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.68,322.44c-.11.15-3.29-2.14-7.09-5.1s-6.79-5.48-6.68-5.63,3.29,2.14,7.09,5.1S89.79,322.3,89.68,322.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.82,354.33a15.22,15.22,0,0,1-2.37-1.85c-1.42-1.2-3.37-2.85-5.56-4.63s-4.2-3.37-5.66-4.52a13.91,13.91,0,0,1-2.29-1.95A13,13,0,0,1,75.51,343c1.53,1.06,3.6,2.59,5.8,4.38s4.12,3.51,5.46,4.8A11.55,11.55,0,0,1,88.82,354.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.33,334.62c.14.11-3.38,4.73-7.86,10.32s-8.24,10-8.39,9.9,3.38-4.74,7.87-10.32S105.19,334.5,105.33,334.62Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Characters--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M371.94,405.48s-2,21.55,12.26,22.62,40.59.64,45.08-2.14,7.91-7.7,8.56-12.2-5.93-14.32-5.93-14.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.23,424.91c0,.14-13.51.26-30.18.26s-30.18-.12-30.18-.26,13.51-.26,30.18-.26S435.23,424.76,435.23,424.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.21,263.68l.81-4.14a1.71,1.71,0,0,0-1.47-2l-4.43-.57s-.64,1-.13,1.8,3.54,1.25,3.54,1.25v4.1Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.79,331.16h0A10.37,10.37,0,0,0,401,320.26c-.28-5.65-.6-11.36-.6-11.36s8.46-1.56,8.33-10-2.15-28-2.15-28h0a29.51,29.51,0,0,0-29.55,4.56l-1.23,1,4.51,45.36A10.38,10.38,0,0,0,390.79,331.16Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.33,259.26l-10,4.78c-.39-3.14-2.83-6.24-2.69-4.66s.12,9.78.12,9.78l-13.88,30c-1.88,4.75-5.76,7.77-8.67,8.5L436,311.77l5.36,17.47,18.36-6.3a15.9,15.9,0,0,0,10-10.24L482,273.89a60.61,60.61,0,0,0,2-7.64A44.3,44.3,0,0,0,484.33,259.26Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.58,360.4s12.8-33.29,13.91-34.39c6.93-6.79,16.52-7,16.52-7l26.11-2.1s20.31-4.4,32.11-7.48l7.4,24.09-22.48,7.58.3,28,7,20.78A58.1,58.1,0,0,1,431,397.4l.93,2.41-60.38,6c-.83-7,5.69-25.26,5.69-25.26l-6.85-27.05-1.22,10.68Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.8,348a7.26,7.26,0,0,0-3.18.29,10.49,10.49,0,0,0-3.26,1.85,43.85,43.85,0,0,0-3.63,3.49,12.9,12.9,0,0,1-5.15,3.42,12.42,12.42,0,0,1-7.09-.08,22,22,0,0,1-7-3.53c-2.2-1.6-4.29-3.47-6.53-5.23a26.84,26.84,0,0,0-7.05-4.24,23,23,0,0,0-7.49-1.56A22.27,22.27,0,0,0,357,345.56a24.07,24.07,0,0,0-6.55,5.82c-.63.83-1.08,1.51-1.37,2a4.83,4.83,0,0,1-.47.7,4.48,4.48,0,0,1,.36-.77,22.15,22.15,0,0,1,7.81-8.1,22.52,22.52,0,0,1,12.68-3.37,23.07,23.07,0,0,1,7.68,1.56,27.08,27.08,0,0,1,7.22,4.32c2.25,1.77,4.33,3.64,6.5,5.22a21.38,21.38,0,0,0,6.79,3.48,11.93,11.93,0,0,0,6.79.13,12.35,12.35,0,0,0,5-3.25,45,45,0,0,1,3.72-3.45,10.9,10.9,0,0,1,3.4-1.81,6,6,0,0,1,2.42-.24A3,3,0,0,1,419.8,348Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.92,373.39c0,.07-.68.13-1.87.52a16.9,16.9,0,0,0-4.57,2.55c-1.79,1.32-3.71,3.17-6.06,5a24.13,24.13,0,0,1-8.72,4.23,26.67,26.67,0,0,1-9.68.59,25.41,25.41,0,0,1-7.61-2.18,25,25,0,0,1-2.68-1.44c-.73-.52-1.37-.95-1.86-1.34a12.74,12.74,0,0,1-1.44-1.33,31.26,31.26,0,0,0,6.16,3.73,26.08,26.08,0,0,0,7.5,2,26.85,26.85,0,0,0,9.46-.62,23.91,23.91,0,0,0,8.53-4.09c2.34-1.78,4.3-3.62,6.15-4.91a15.34,15.34,0,0,1,4.76-2.43,7.91,7.91,0,0,1,1.43-.27A1.58,1.58,0,0,1,420.92,373.39Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.81,318.56a5.42,5.42,0,0,1,2.11-.8,13.14,13.14,0,0,1,10.43,2.11,5.57,5.57,0,0,1,1.63,1.55,19.34,19.34,0,0,1-1.87-1.2A15,15,0,0,0,427,318.17,19.2,19.2,0,0,1,424.81,318.56Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.25,401.5a26.87,26.87,0,0,0,4.72-1.6,32.81,32.81,0,0,0,4.64-2.76l5.44-3.88a32.24,32.24,0,0,1,5.87-3.29,21.6,21.6,0,0,1,5.34-1.36,20.26,20.26,0,0,1,3.7-.1,5.33,5.33,0,0,1,1.34.2,45.52,45.52,0,0,0-5,.32,22.85,22.85,0,0,0-5.18,1.46,33.22,33.22,0,0,0-5.74,3.27c-1.94,1.33-3.75,2.69-5.46,3.84a30.87,30.87,0,0,1-4.79,2.69c-.71.32-1.4.53-2,.73s-1.13.28-1.56.37A5.94,5.94,0,0,1,394.25,401.5Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.43,263.29c15.3,1.47,9.42,21.54,13.24,27.62,1.42,2.25,3.76,3.93,5.64,5.91s3.34,4.57,2.52,7.07c-.7,2.17-3,4.12-2.47,6.29.31,1.15,1.38,2,2.19,2.94a9.11,9.11,0,0,1,1.76,8.3,16.46,16.46,0,0,1-5,7.64c-6.84,6.36-18,9.07-27.5,6.7-2.82-.7-5.72-1.82-8.59-1.15-1.76.41-3.24,1.46-4.87,2.19-6.3,2.84-14.66.31-18.14-4.83s-2.43-12,1.63-17c2.91-3.59,7.41-6.86,7.35-11.15s-4.72-8.05-3.11-12.09c1-2.61,4.43-4.21,5.45-6.82s-.73-5.54-1.06-8.37c-.45-3.82,1.84-7.55,4.49-10.73,3.35-4,7.76-7.77,13.35-8.85s12.28,1.58,13.08,6.36",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.91,337.08a12.85,12.85,0,0,0,3.27-1,10,10,0,0,0,3.16-2.37,9.44,9.44,0,0,0,2.25-4.66,9.82,9.82,0,0,0-.87-6.18c-.48-1.05-1.08-2.09-1.64-3.21a11.85,11.85,0,0,1-1.27-3.69,6.19,6.19,0,0,1,.88-4,16.15,16.15,0,0,1,2.81-3.21,18.3,18.3,0,0,0,2.89-3.14,5.26,5.26,0,0,0,1-4,7.74,7.74,0,0,0-2.23-3.62c-1-1-2.11-2-3.05-3.13a7.84,7.84,0,0,1-1.85-3.88,12.17,12.17,0,0,1,.19-4.1c.55-2.6,1.34-4.95,1.66-7.24a19,19,0,0,0,.05-6.38,11,11,0,0,0-4.86-7.54,9.6,9.6,0,0,0-3.19-1.17h.23a4.38,4.38,0,0,1,.66.08,7.56,7.56,0,0,1,2.41.88,11.11,11.11,0,0,1,5.17,7.67,19.29,19.29,0,0,1,0,6.53c-.3,2.34-1.09,4.74-1.6,7.28a11.33,11.33,0,0,0-.17,3.9,7.17,7.17,0,0,0,1.73,3.59c.9,1.07,2,2,3,3.1a8.2,8.2,0,0,1,2.39,3.91,5.83,5.83,0,0,1-1.07,4.46,18.94,18.94,0,0,1-3,3.24,16,16,0,0,0-2.72,3.08,5.55,5.55,0,0,0-.82,3.67c.35,2.53,1.89,4.61,2.81,6.77a10.21,10.21,0,0,1,.84,6.45,9.79,9.79,0,0,1-2.42,4.82,10.12,10.12,0,0,1-3.31,2.36,9.74,9.74,0,0,1-2.47.71c-.29,0-.52.05-.67.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.9,282.72a9.32,9.32,0,0,1-.3-1.73,30.05,30.05,0,0,1-.22-4.8,16.6,16.6,0,0,1,1.74-6.94,17.69,17.69,0,0,1,5.93-6.42c5.26-3.46,11.47-3.95,15.3-2.43a7.78,7.78,0,0,1,3.85,2.89,5,5,0,0,1,.57,1.18,1.21,1.21,0,0,1,.1.45,14.76,14.76,0,0,0-.87-1.5,7.79,7.79,0,0,0-3.79-2.62c-3.72-1.36-9.73-.83-14.83,2.53a17.5,17.5,0,0,0-5.77,6.18,16.7,16.7,0,0,0-1.8,6.7,36.11,36.11,0,0,0,0,4.76A11,11,0,0,1,372.9,282.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.27,268a6.73,6.73,0,0,0-2.95.33,8.6,8.6,0,0,0-5.05,6,18.32,18.32,0,0,0-.42,5.6c.1,2,.43,4.21.52,6.54a15.71,15.71,0,0,1-1.11,7.22c-1,2.41-3.33,4.08-4.06,6.54a6.36,6.36,0,0,0,.21,3.71c.38,1.21.94,2.36,1.41,3.54a11.37,11.37,0,0,1,.91,3.67,8.37,8.37,0,0,1-.69,3.57,43.57,43.57,0,0,1-3.29,5.71,11.8,11.8,0,0,0-2,5.19,8.27,8.27,0,0,0,1,4.44,17.09,17.09,0,0,0,1.91,3c.59.77,1.09,1.35,1.41,1.74a4.68,4.68,0,0,1,.49.63,4.16,4.16,0,0,1-.58-.54c-.35-.37-.88-.93-1.51-1.68a17.38,17.38,0,0,1-2-2.95,8.52,8.52,0,0,1-1.09-4.63,12.24,12.24,0,0,1,2-5.42,43.68,43.68,0,0,0,3.2-5.66,7.75,7.75,0,0,0,.64-3.34,10.78,10.78,0,0,0-.89-3.47c-.46-1.15-1-2.31-1.43-3.58a7,7,0,0,1-.22-4.05,10.63,10.63,0,0,1,2-3.5,15,15,0,0,0,2.08-3.12,15.35,15.35,0,0,0,1.1-7c-.08-2.29-.39-4.47-.47-6.53a18.54,18.54,0,0,1,.51-5.74,8.77,8.77,0,0,1,5.38-6.07,5,5,0,0,1,2.84-.17Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.72,384.78a11.34,11.34,0,0,1,.67,1.64c.41,1.06,1,2.6,1.78,4.46s1.81,4.06,3.07,6.42,2.84,4.87,4.22,7.66a21.89,21.89,0,0,1,2.6,8.4,8.31,8.31,0,0,1-.81,3.79,17.87,17.87,0,0,1-1.64,2.93,24.21,24.21,0,0,1-3.1,3.71,12.44,12.44,0,0,1-1,.87,1.55,1.55,0,0,1-.39.25s.46-.43,1.23-1.26a27.87,27.87,0,0,0,2.94-3.77,17.91,17.91,0,0,0,1.55-2.9,7.82,7.82,0,0,0,.73-3.6A21.87,21.87,0,0,0,435,405.2c-1.37-2.77-2.95-5.27-4.18-7.67a68.19,68.19,0,0,1-3-6.51c-.75-1.89-1.28-3.45-1.63-4.53-.17-.55-.3-1-.38-1.26A2,2,0,0,1,425.72,384.78Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.9,296.19a1.71,1.71,0,0,1-.06.26c0,.2-.12.44-.21.75-.21.69-.49,1.64-.85,2.85l-3.24,10.46c-.35,1.1-.69,2.26-1.1,3.46a13.16,13.16,0,0,1-1.9,3.5,15.9,15.9,0,0,1-3,3c-.58.45-1.18.88-1.81,1.29a9.25,9.25,0,0,1-1,.59l-1.05.46c-5.71,2.26-12.1,4.33-18.8,6.53l-.47.15.17-.33c.44,1.44.88,2.86,1.31,4.25l.07.24-.24.08-22.49,7.54.15-.2c0,1.69,0,3.31,0,4.84s.09,3,.09,4.37c0,2.75-.05,5.13-.08,7.09s0,3.49,0,4.53c0,.49,0,.89,0,1.19a1.85,1.85,0,0,1,0,.41,1.87,1.87,0,0,1-.05-.4c0-.27,0-.67-.08-1.2-.05-1-.09-2.58-.09-4.54s0-4.34,0-7.07c0-1.37-.13-2.81-.13-4.36s-.05-3.17-.08-4.86v-.15l.15-.05,22.47-7.63-.17.32c-.43-1.39-.86-2.81-1.3-4.24l-.08-.25.25-.08.46-.15c6.69-2.19,13.1-4.25,18.77-6.47l1-.45a8.21,8.21,0,0,0,.94-.55c.62-.41,1.22-.82,1.79-1.26a16,16,0,0,0,3-2.9,12.64,12.64,0,0,0,1.86-3.38c.42-1.17.77-2.34,1.13-3.43,1.42-4.37,2.58-7.91,3.39-10.41.4-1.2.72-2.14.95-2.82l.26-.74A.86.86,0,0,1,474.9,296.19Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.53,261.07c.17-.08,3.68-9.87,4.13-10.79.68-1.41.75.75.39,3.41-.3,2.25-.72,5.57-.72,5.57Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.39,275.58s.07.25.18.74.23,1.22.37,2.17.26,2.1.36,3.45.16,2.89.36,4.57a10.49,10.49,0,0,0,1.8,5.09c1.15,1.59,2.77,3,4.28,4.7a23,23,0,0,1,2.19,2.72,7.58,7.58,0,0,1,1.35,3.43,3.62,3.62,0,0,1-.35,1.93,8.06,8.06,0,0,1-1.09,1.6,9.37,9.37,0,0,0-1.11,1.48,2.33,2.33,0,0,0-.17,1.71c.57,2.42,2.82,4.17,3.45,6.67a11.38,11.38,0,0,1-.37,7.09,15.22,15.22,0,0,1-3.47,5.42,21.17,21.17,0,0,1-4.51,3.33,41.74,41.74,0,0,1-7.46,3.07c-.91.29-1.62.5-2.1.63a3.47,3.47,0,0,1-.75.18,6.09,6.09,0,0,1,.72-.28l2.06-.72a45.87,45.87,0,0,0,7.35-3.2,20.75,20.75,0,0,0,4.38-3.32,14.93,14.93,0,0,0,3.33-5.28,11,11,0,0,0,.33-6.77,11.21,11.21,0,0,0-1.68-3.23,10.31,10.31,0,0,1-1.79-3.49,2.82,2.82,0,0,1,.22-2,9.57,9.57,0,0,1,1.17-1.57,4.22,4.22,0,0,0,1.33-3.16,7.07,7.07,0,0,0-1.26-3.2,23.46,23.46,0,0,0-2.12-2.67,63.63,63.63,0,0,1-4.29-4.77,10.8,10.8,0,0,1-1.8-5.3c-.18-1.7-.21-3.24-.29-4.59s-.18-2.5-.27-3.45-.2-1.67-.28-2.17A3.33,3.33,0,0,1,413.39,275.58Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.29,261.48,316,308.72l20.23,1.91,1.12-11.47s7.13,1.76,9.3-4.84c1.38-4.21,2.62-37.24,2.62-37.24Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351,262.6c.56,4.42-5.62,7-5.62,7L344.26,280a20.49,20.49,0,0,0-2.91,0c.53-4.91-5.8-3.95-6.44-.6s3,5.36,3,5.36c-2.53,3.89-3.56,5.93-7.15,9.57-3.88,3.94-6,4.26-10,4.14l-4.42-.21s-1.57-3.77-2.73-12.69c-.55-4.29-3.9-9.91-2.95-16.88,2.71-19.82,21.7-17.73,21.7-17.73C342.28,251.24,349.66,252.34,351,262.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.62,269.25A15,15,0,0,0,355.2,259a7.4,7.4,0,0,0-.36-5.48c-.93-1.63-3.14-2.61-4.79-1.7A5.49,5.49,0,0,0,339.38,250a4.92,4.92,0,0,0-5.45-1.53,7,7,0,0,0-4.09,4.21,12.23,12.23,0,0,0-.49,6",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.42,255.9c0-.07.35-.23,1-.29a5.26,5.26,0,0,1,4.46,1.93c.4.5.53.89.47.92a7.7,7.7,0,0,0-5.92-2.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.59,253.62a9.09,9.09,0,0,0,.09,2.14c.28,1.15,1.09,1.77,1,1.9s-.3,0-.64-.31a2.91,2.91,0,0,1-.89-1.45,3,3,0,0,1,0-1.7C314.34,253.78,314.53,253.59,314.59,253.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.23,274.4s0,.05-.15.14a4.48,4.48,0,0,1-.51.36,5.91,5.91,0,0,1-2.25.8,11.48,11.48,0,0,1-8.22-2.58,7.7,7.7,0,0,1-2-2.16,4.13,4.13,0,0,1-.53-3.17,2.95,2.95,0,0,1,5.57-.91,4.52,4.52,0,0,1,.31,3.82,8.75,8.75,0,0,1-2.12,3.37,9.56,9.56,0,0,1-7.66,2.82,10,10,0,0,1-4-1.3,7.59,7.59,0,0,1-2.92-2.92,4.29,4.29,0,0,1-.25-4,3.6,3.6,0,0,1,3.34-1.86,2.4,2.4,0,0,1,1.71.93,3.26,3.26,0,0,1,.59,1.77,6.4,6.4,0,0,1-.85,3.33,8.15,8.15,0,0,1-4.68,3.81,7.2,7.2,0,0,1-5-.22,8.18,8.18,0,0,1-3.07-2.2,6.84,6.84,0,0,1-1.24-2,3.08,3.08,0,0,1-.2-.58c0-.14,0-.21,0-.21a9.2,9.2,0,0,0,1.64,2.69,8.09,8.09,0,0,0,3,2.06,7,7,0,0,0,4.75.14,7.82,7.82,0,0,0,4.39-3.66,6,6,0,0,0,.78-3.09,2.73,2.73,0,0,0-.51-1.5,1.9,1.9,0,0,0-1.36-.74,3.12,3.12,0,0,0-2.84,1.61,3.81,3.81,0,0,0,.26,3.49,8.38,8.38,0,0,0,6.54,3.93A9.05,9.05,0,0,0,335,273.7a8.22,8.22,0,0,0,2-3.16,4.09,4.09,0,0,0-.24-3.4,2.72,2.72,0,0,0-2.73-1.39,2.77,2.77,0,0,0-2,2.15,3.76,3.76,0,0,0,.46,2.85,7.46,7.46,0,0,0,1.87,2.07,11.43,11.43,0,0,0,8,2.67A7.25,7.25,0,0,0,345.23,274.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.93,305.49s-23.82-3.89-33.36,23l-6.86,21,19.91,3.81-1.41,53.26,61.7-5.56-3.56-39.54-4.75-.79,1-7.68,23.89-8.58S355,302.83,334.28,306.26Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,428l-38.07,1.87c-10,1.23-27.39,1.27-38.08.47-14.28-1.07-11.65-23.66-11.65-23.66l61.93-5.81a25.29,25.29,0,0,1,15.23-.44S369.56,425.5,383,428Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.71,349.56s-5.53,24-5.6,27.22c-.1,4.19,5.23,11.41,10.11,12.39,7.82,1.57,15.4-5.26,15.4-5.26l.95-32.23Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.07,378.69l3.54,1.45c3.33,1,5.14,1.75,6.4,1.27,1.68-.63.51-2.45.51-2.45s2.65.19,3-1.31a1.52,1.52,0,0,0-.79-1.6s2.38.07,3.14-.62c1-.92-.14-2.15-.14-2.15,3.51-.54,4-2.35,3.41-2.79s-3.17-.36-3.17-.36c-2.06-.25-7.71-.84-4.69-2.82s4.6-4.63,4.53-5.65a1.13,1.13,0,0,0-2.11-.33,13.45,13.45,0,0,1-2.61,2.53,8.53,8.53,0,0,1-2.56,1.4c-1.09.37-2,.64-2.82.85l-4.41,1.7Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.67,339.34a1.33,1.33,0,0,1,.11.46l.21,1.33.71,4.91c.59,4.22,1.4,9.91,2.28,16.19s1.65,12.07,2.14,16.23c.25,2.08.43,3.76.54,4.93l.11,1.34a1.78,1.78,0,0,1,0,.48,1.46,1.46,0,0,1-.11-.47c-.06-.36-.13-.8-.21-1.33-.18-1.24-.42-2.9-.7-4.91-.6-4.22-1.4-9.91-2.29-16.19s-1.65-12.06-2.14-16.22c-.24-2.08-.43-3.77-.54-4.93,0-.54-.08-1-.11-1.35A2.38,2.38,0,0,1,289.67,339.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M334.87,330.5s-.27,18.47,2.23,30.43a7.6,7.6,0,0,1-1.18,5.08c-.93,1.45-2.81,1.87-4.5,2.17l-14.79,2.62a45.23,45.23,0,0,1,11.9,10.37c1.84,2.29,3.47,4.77,5.44,6.95s6.83,5.47,9.77,5.53c5.63.12,9.45-6.77,11.52-8.87l-6.66-24,.79-6.88Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M289.92,341.76q-1.6,9.86-2.28,19.83c-.27,4.11-.42,8.3.64,12.28s3.51,7.78,7.22,9.56Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M348.6,360.74l-5.88,12.64-39-4.86L302.24,367c-.63-.53-1.36-1.17-2.18-2a8.69,8.69,0,0,1-1.71-2.37,12.78,12.78,0,0,1-1.28-3.41,1.13,1.13,0,0,0-2.05-.6c-.5.89-.21,4,1.67,7s-3.47,1.19-5.44.54c0,0-2.31-1.18-3-1s-1.05,2,1.89,4c0,0-1.59.6-1.05,1.89.4.94,2.58,1.9,2.58,1.9a1.52,1.52,0,0,0-1.4,1.1c-.3,1.52,2.18,2.49,2.18,2.49s-1.84,1.14-.59,2.43c.93,1,2.87,1.1,6.33,1.59l.77,0c9.91,2.94,48.58,13.76,55.28,5.46a67.58,67.58,0,0,0,12.15-22.39Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.06,344.78s16.49,24.29,23,26.62,51.6,10.46,51.6,10.46l2.11-16.15S380.37,352.76,379,351.76c-1-.74-12.16-19.84-18.66-29.16-6.36-9.14-18.16-17.11-24.26-5-.06.12.07-.11,0,0C328.88,329,343.06,344.78,343.06,344.78Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.17,323.84a23.44,23.44,0,0,0-3-1,20,20,0,0,0-8.61.09,42.13,42.13,0,0,0-11.86,4.95c-4.24,2.34-8.86,5.27-14.36,6.79a21.51,21.51,0,0,1-8.24.74,24.42,24.42,0,0,1-7.36-2.26c-4.44-2.11-8.09-4.59-11.49-6a21.75,21.75,0,0,0-8.39-2,22.93,22.93,0,0,0-3.17.27,10.34,10.34,0,0,1,3.17-.47,20.79,20.79,0,0,1,8.53,1.89c3.46,1.38,7.15,3.83,11.55,5.89a23.91,23.91,0,0,0,7.22,2.19,21.13,21.13,0,0,0,8-.73c5.41-1.49,10-4.38,14.27-6.71a41.57,41.57,0,0,1,12-4.89,19.48,19.48,0,0,1,8.73.08A10.69,10.69,0,0,1,361.17,323.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.54,330.42a27.33,27.33,0,0,0-3.27-1.07,21.63,21.63,0,0,0-9.31.08c-3.89.78-8.23,2.76-12.81,5.35s-9.57,5.69-15.51,7.33a23.25,23.25,0,0,1-8.88.79,26,26,0,0,1-7.95-2.44c-4.79-2.27-8.73-4.94-12.41-6.46a23.25,23.25,0,0,0-9.06-2.19,23.8,23.8,0,0,0-3.43.31,11.4,11.4,0,0,1,3.43-.51,22.84,22.84,0,0,1,9.21,2.05c3.73,1.49,7.72,4.14,12.46,6.37a26.12,26.12,0,0,0,7.81,2.37,22.75,22.75,0,0,0,8.69-.8c5.84-1.61,10.8-4.72,15.41-7.24s9-4.55,13-5.29a21.2,21.2,0,0,1,9.42.08A12,12,0,0,1,365.54,330.42Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.77,311.07a15.63,15.63,0,0,0-2.29.63,10.38,10.38,0,0,0-4.75,4.19,12.06,12.06,0,0,0-1.65,4.09,15.74,15.74,0,0,0-.18,5.07,27.25,27.25,0,0,0,1.26,5.51,39.67,39.67,0,0,0,2.35,5.62,93.58,93.58,0,0,0,6.25,10c2.09,3,4.07,5.59,5.75,7.77s3.1,3.9,4.08,5.09l1.12,1.37a2.39,2.39,0,0,1,.37.5,3.71,3.71,0,0,1-.44-.43c-.29-.29-.7-.73-1.21-1.31-1-1.15-2.48-2.84-4.21-5s-3.73-4.75-5.85-7.72a88.34,88.34,0,0,1-6.32-10.07,38.34,38.34,0,0,1-2.37-5.69,26.63,26.63,0,0,1-1.26-5.62,16.58,16.58,0,0,1,.23-5.21,12.61,12.61,0,0,1,1.77-4.2,10.27,10.27,0,0,1,5-4.17A6.38,6.38,0,0,1,342.77,311.07Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trunk--inject-22"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M470.31,463.08H282a18.68,18.68,0,0,1-18.68-18.68h0A18.67,18.67,0,0,1,282,425.73H470.31A18.67,18.67,0,0,1,489,444.4h0A18.68,18.68,0,0,1,470.31,463.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 281.35,
    cy: 444.4,
    r: 18.67,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.38,441.11s.08.07.19.23a2.65,2.65,0,0,1,.33.79,5.56,5.56,0,0,1-.32,3.1,7.48,7.48,0,0,1-1,2,2.89,2.89,0,0,1-1,.82,3.46,3.46,0,0,1-1.31.32,10.12,10.12,0,0,1-2.75-.3,5.15,5.15,0,0,1-2.61-1.48,3.28,3.28,0,0,1-.83-2.93,4.66,4.66,0,0,1,1.42-2.44,10.49,10.49,0,0,1,4.15-2h0l.67,0h.07a6.92,6.92,0,0,1,2.32,1.21c.47.42.6.74.58.75s-.22-.26-.69-.61a7.77,7.77,0,0,0-2.32-1h.06l-.66.06h0a10.55,10.55,0,0,0-3.93,2,4.16,4.16,0,0,0-1.25,2.19,2.8,2.8,0,0,0,.71,2.48,4.66,4.66,0,0,0,2.36,1.33,10,10,0,0,0,2.6.32,2.47,2.47,0,0,0,2-.93,7.31,7.31,0,0,0,1-1.82,5.58,5.58,0,0,0,.47-2.93A9.39,9.39,0,0,0,285.38,441.11Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290,441.48a2,2,0,0,1,.29.53,10,10,0,0,1,.59,1.63,6.44,6.44,0,0,1,.17,2.74,7,7,0,0,1-1.59,3.29,11.28,11.28,0,0,1-8.44,3.85,11,11,0,0,1-5.43-1.37,11.7,11.7,0,0,1-4.34-4.17,8.67,8.67,0,0,1-.95-2.13,3.4,3.4,0,0,1,.12-2.35,7.23,7.23,0,0,1,3.23-2.94,11.64,11.64,0,0,0,1.65-1.12,9.26,9.26,0,0,0,1.29-1.43,11.75,11.75,0,0,1,1.28-1.45,4,4,0,0,1,1.68-.89h0a7.65,7.65,0,0,1,5.36.27,8.11,8.11,0,0,1,3.33,2.44,11.56,11.56,0,0,1,1.43,2.23,3.93,3.93,0,0,1,.35.86,19.71,19.71,0,0,0-2-2.93,8,8,0,0,0-3.28-2.27,7.26,7.26,0,0,0-5.08-.19h0a3.49,3.49,0,0,0-1.48.81,11.18,11.18,0,0,0-1.21,1.4,9.87,9.87,0,0,1-1.34,1.51,12.76,12.76,0,0,1-1.72,1.18,6.75,6.75,0,0,0-3,2.72c-.59,1.26.07,2.75.81,4a11.19,11.19,0,0,0,4.14,4A10.62,10.62,0,0,0,281,453a11,11,0,0,0,8.16-3.61,6.7,6.7,0,0,0,1.58-3.1,6.57,6.57,0,0,0-.07-2.65C290.36,442.25,290,441.5,290,441.48Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,430.75l.23,0,.69-.05a23.43,23.43,0,0,1,2.63,0,11.64,11.64,0,0,1,4.1.84,8.11,8.11,0,0,1,4,3.81,21.15,21.15,0,0,1,1.88,6.45,22.07,22.07,0,0,1,.41,3.73,6.19,6.19,0,0,1-1.23,3.83,23.73,23.73,0,0,1-3,3,33,33,0,0,1-3.43,2.68,17.5,17.5,0,0,1-8.53,3.23,11.38,11.38,0,0,1-8.62-2.76,10.8,10.8,0,0,1-2.46-3.65,24.47,24.47,0,0,1-1.27-4,15.06,15.06,0,0,1-.17-7.7,12.61,12.61,0,0,1,3.54-5.69,13.94,13.94,0,0,1,4.74-2.88,16.41,16.41,0,0,1,4.08-.9,13.48,13.48,0,0,1,3.56.08s-.32,0-.92,0a19.75,19.75,0,0,0-2.62.13,16.72,16.72,0,0,0-4,1,13.89,13.89,0,0,0-4.59,2.86,12.39,12.39,0,0,0-3.38,5.55,14.62,14.62,0,0,0,.23,7.46c.65,2.57,1.51,5.39,3.61,7.38a10.88,10.88,0,0,0,8.23,2.61,17.15,17.15,0,0,0,8.29-3.13,34.2,34.2,0,0,0,3.38-2.63,23.33,23.33,0,0,0,2.91-2.88,5.62,5.62,0,0,0,1.16-3.54,21.93,21.93,0,0,0-.37-3.66,21.3,21.3,0,0,0-1.78-6.35,7.82,7.82,0,0,0-3.78-3.71,12.07,12.07,0,0,0-4-.91c-1.13-.08-2-.07-2.62-.07A6.52,6.52,0,0,1,282,430.75Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.55,443.06l-.49,0-1.42.07-5.47.23c-4.76.17-11.64.42-20.14.6s-18.65.25-29.89-.11c-5.63-.19-11.53-.49-17.63-1s-12.41-1.2-18.85-1.95c-12.89-1.54-25.18-3-36.41-3.39a193.52,193.52,0,0,0-29.8,1.15,164.73,164.73,0,0,0-19.79,3.6c-2.31.59-4.09,1.06-5.29,1.42l-1.37.38-.48.11.46-.16,1.36-.43c1.19-.39,3-.89,5.27-1.51a153,153,0,0,1,19.79-3.77,189.33,189.33,0,0,1,29.86-1.27c11.27.35,23.57,1.81,36.46,3.35,6.44.75,12.73,1.47,18.83,2s12,.82,17.6,1c11.24.39,21.37.34,29.87.22s15.38-.32,20.14-.44l5.48-.12,1.42,0A3.69,3.69,0,0,1,487.55,443.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487,435.84a57.72,57.72,0,0,1-7.09,2.29A91.78,91.78,0,0,1,459.84,441a140,140,0,0,1-14-.22c-5-.32-10.4-.89-16-1.62-11.25-1.43-23.53-3.6-36.56-4.58a304.92,304.92,0,0,0-36.82-.39c-11.31.5-21.48,1.45-30,2.28s-15.42,1.65-20.18,2.18l-5.49.61-1.43.14c-.32,0-.49,0-.49,0l.49-.08,1.42-.2,5.47-.7c4.76-.59,11.64-1.44,20.17-2.34s18.69-1.87,30-2.4a299.5,299.5,0,0,1,36.88.35c13.06,1,25.35,3.17,36.58,4.62,5.62.75,11,1.33,16,1.67s9.71.43,14,.29a94.59,94.59,0,0,0,20.05-2.66c1.16-.28,2.19-.56,3.07-.83s1.64-.47,2.23-.68l1.37-.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.66,450.47l-.52.15-1.54.39c-1.35.34-3.36.78-6,1.29a131,131,0,0,1-22.32,2.21c-2.37,0-4.85,0-7.44-.12-1.29-.07-2.61-.13-3.95-.24a17.35,17.35,0,0,1-4.1-.59,6,6,0,0,1-1.94-1,2.74,2.74,0,0,1-1.13-1.95,2.65,2.65,0,0,1,.87-2.12,6,6,0,0,1,2-1.16,89.73,89.73,0,0,1,8.9-2.26,114.51,114.51,0,0,1,40.59-1c1.79.25,3.55.6,5.32.94a9.31,9.31,0,0,1,4.86,2.32,4.11,4.11,0,0,1,1.1,2.52,5,5,0,0,1-.61,2.65,6.56,6.56,0,0,1-1.75,2,8.92,8.92,0,0,1-2.33,1.21,24.76,24.76,0,0,1-5,1c-1.66.21-3.3.45-4.93.62-3.26.38-6.46.67-9.58.91a225.83,225.83,0,0,1-33.27-.09,218.49,218.49,0,0,1-22.24-2.88c-2.61-.47-4.62-.89-6-1.19l-1.55-.34c-.35-.08-.53-.14-.53-.14s.19,0,.54.09l1.56.29c1.37.27,3.38.65,6,1.09,5.22.88,12.8,2,22.24,2.71a227.69,227.69,0,0,0,33.2,0c3.12-.24,6.31-.54,9.56-.92,1.63-.18,3.27-.42,4.92-.63a23.81,23.81,0,0,0,4.9-1,6.53,6.53,0,0,0,3.8-3,4.4,4.4,0,0,0,.56-2.37,3.62,3.62,0,0,0-1-2.2,8.84,8.84,0,0,0-4.6-2.16c-1.74-.34-3.5-.69-5.28-.94a114.72,114.72,0,0,0-40.41,1,89.67,89.67,0,0,0-8.83,2.22,5.32,5.32,0,0,0-1.82,1.06,2.2,2.2,0,0,0-.74,1.76,2.31,2.31,0,0,0,1,1.63,5.77,5.77,0,0,0,1.8.91,17.4,17.4,0,0,0,4,.58c1.34.11,2.65.19,3.94.26,2.58.12,5.05.16,7.42.15a135,135,0,0,0,22.28-2c2.6-.47,4.62-.89,6-1.19l1.54-.34A5.12,5.12,0,0,1,371.66,450.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.79,457.18l-.25,0-.74-.12-2.82-.51c-1.22-.23-2.71-.5-4.46-.75s-3.72-.62-5.93-.86l-3.46-.43c-1.2-.15-2.46-.23-3.76-.36-2.59-.28-5.38-.42-8.31-.6-5.86-.25-12.32-.3-19.08,0s-13.19,1.07-19,1.92c-2.9.48-5.66.9-8.21,1.44-1.28.26-2.52.48-3.71.74l-3.39.78c-2.17.47-4.1,1-5.81,1.46s-3.18.85-4.36,1.21l-2.75.79-.72.19-.25.05s.07,0,.23-.1l.7-.24,2.73-.88c1.18-.39,2.63-.85,4.34-1.3s3.63-1,5.8-1.53l3.4-.82c1.18-.28,2.42-.5,3.7-.77,2.56-.56,5.32-1,8.22-1.49,5.82-.88,12.26-1.61,19-2s13.26-.27,19.14,0c2.93.19,5.72.34,8.33.64,1.3.14,2.56.23,3.76.39l3.46.46c2.21.27,4.19.65,5.93.94s3.24.58,4.45.85l2.8.6.73.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.58,426.93a2.31,2.31,0,0,1-.5.24l-1.46.59c-.64.26-1.43.55-2.36.85s-2,.67-3.16,1-2.48.68-3.89,1-2.93.58-4.53.85a79,79,0,0,1-10.53.84,78.21,78.21,0,0,1-10.53-.71c-1.61-.25-3.13-.47-4.54-.79s-2.72-.61-3.91-.93-2.24-.65-3.17-.93-1.73-.57-2.36-.82l-1.48-.57a3.92,3.92,0,0,1-.5-.23,2,2,0,0,1,.54.13l1.5.48c.65.22,1.44.48,2.38.73s2,.6,3.18.86,2.49.6,3.9.85,2.93.51,4.52.75a75.89,75.89,0,0,0,20.93-.13c1.59-.26,3.11-.48,4.51-.8s2.7-.6,3.88-.9,2.24-.63,3.18-.9,1.72-.53,2.37-.76l1.49-.5A2,2,0,0,1,475.58,426.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362,425.5a5.58,5.58,0,0,1-.72.13l-2.07.3c-1.8.29-4.39.73-7.56,1.43l-11.14,2.56a86.14,86.14,0,0,1-13.85,2.1,50.07,50.07,0,0,1-7.28-.17c-2.34-.25-4.57-.63-6.69-1-4.23-.8-8-1.61-11.24-2a38,38,0,0,0-7.65-.24c-.91,0-1.6.17-2.08.23a3.3,3.3,0,0,1-.73.06,6.16,6.16,0,0,1,.71-.17,18.78,18.78,0,0,1,2.08-.32,35.11,35.11,0,0,1,7.71.08c3.26.32,7.06,1.1,11.29,1.87,2.11.38,4.33.75,6.65,1a51.93,51.93,0,0,0,7.2.16,89.43,89.43,0,0,0,13.78-2.05c4.2-.9,8-1.8,11.16-2.45s5.8-1.05,7.61-1.27c.91-.11,1.61-.16,2.09-.2A3.35,3.35,0,0,1,362,425.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.88,425.51a4.83,4.83,0,0,1,.79-.05l2.29,0,8.39-.08,12.46-.06a26.24,26.24,0,0,1,3.63.13,19.55,19.55,0,0,1,3.7.84,20.46,20.46,0,0,1,6.85,4,18.36,18.36,0,0,1,6.43,13.56,19.77,19.77,0,0,1-3.92,11.75,20.78,20.78,0,0,1-3.3,3.5,19.63,19.63,0,0,1-3,2l-1.2.58c-.35.14-.66.24-.91.33a3.51,3.51,0,0,1-.76.24,5.48,5.48,0,0,1,.73-.34c.23-.1.54-.21.88-.37l1.16-.62a20.2,20.2,0,0,0,2.93-2.05,21.29,21.29,0,0,0,3.2-3.5,19.57,19.57,0,0,0,3.73-11.52,18,18,0,0,0-6.29-13.18,19.94,19.94,0,0,0-6.67-3.93,18.75,18.75,0,0,0-3.6-.84,26.69,26.69,0,0,0-3.56-.14l-12.46-.06-8.4-.08-2.29-.05A3.71,3.71,0,0,1,444.88,425.51Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M437.94,425.73c-1.36,4.46-2.84,7.39-6.84,9.78s-13.8,6.26-18.3,7.46c-19.24,5.14-33.2,6.84-53.07,5.49s-41.3-10.62-57.07-22.77Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.71,443.72a4.14,4.14,0,0,1-2.08-2.35,12.1,12.1,0,0,1-.84-3.32,23.81,23.81,0,0,0-.75-4,15.46,15.46,0,0,0-3.81-6.28c-1.35-1.34-2.39-1.95-2.34-2a2.27,2.27,0,0,1,.76.37,12.57,12.57,0,0,1,1.84,1.39,14.66,14.66,0,0,1,4.05,6.39,21.92,21.92,0,0,1,.72,4.12,13.23,13.23,0,0,0,.71,3.24A7,7,0,0,0,337.71,443.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.81,425.73c.1,0-.06,1.31.28,3.35a24.67,24.67,0,0,0,.92,3.52c.44,1.29,1,2.68,1.68,4.14a40.83,40.83,0,0,1,1.64,4.22,16.24,16.24,0,0,1,.71,3.64,10,10,0,0,1-.13,2.5,2.2,2.2,0,0,1-.27.88,18.61,18.61,0,0,0,0-3.34,17.35,17.35,0,0,0-.8-3.54c-.42-1.3-1-2.69-1.66-4.15a43.33,43.33,0,0,1-1.66-4.2,20.93,20.93,0,0,1-.82-3.62,11.58,11.58,0,0,1-.07-2.5A2.87,2.87,0,0,1,351.81,425.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.34,448.67a12.83,12.83,0,0,0,.6-3.49,13,13,0,0,0-.56-3.77,23.86,23.86,0,0,0-1.83-4.35,78.33,78.33,0,0,1-3.91-7.76,9.36,9.36,0,0,1-.53-2.6,3.19,3.19,0,0,1,0-1,17.13,17.13,0,0,0,.84,3.44c.84,2,2.44,4.65,4,7.65a22.59,22.59,0,0,1,1.83,4.46,12.66,12.66,0,0,1,.47,3.92,8.72,8.72,0,0,1-.52,2.6A2.78,2.78,0,0,1,379.34,448.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.35,425.73a4,4,0,0,1-.24.85,5.68,5.68,0,0,0-.16,2.34,23.73,23.73,0,0,0,.87,3.44,16.62,16.62,0,0,1,.85,4.35,13.08,13.08,0,0,1-2.22,7.68,11.53,11.53,0,0,1-1.58,1.86,3.21,3.21,0,0,1-.71.55c-.07-.07.91-.9,2-2.61a13.52,13.52,0,0,0,2-7.46,17.92,17.92,0,0,0-.79-4.24,19.9,19.9,0,0,1-.78-3.54,5.26,5.26,0,0,1,.34-2.43A2.19,2.19,0,0,1,399.35,425.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.08,441.87c-.08,0,.45-.85.87-2.31a10.42,10.42,0,0,0,0-5.81c-.67-2.2-1.88-4-2.33-5.53a5,5,0,0,1-.36-2.49c.09,0,.13.95.71,2.36s1.76,3.19,2.48,5.51a9.87,9.87,0,0,1-.16,6.07A5.53,5.53,0,0,1,417.08,441.87Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.54,435.44a6.18,6.18,0,0,1-1.05.44,12.43,12.43,0,0,1-3.2.59,21.21,21.21,0,0,1-5.13-.41,40.1,40.1,0,0,0-6.73-.74c-2.5-.11-5.29-.22-8.22-.5a29.05,29.05,0,0,0-9.29,1c-3.21.82-6.47,2.09-9.91,3.25a49.25,49.25,0,0,1-10.94,2.59,54.83,54.83,0,0,1-11.25-.06c-3.62-.41-7.08-1-10.34-1.62-6.54-1.28-12.41-2.53-17.41-3.08a54.06,54.06,0,0,0-11.87-.19,16.48,16.48,0,0,0-1.85.24l-1.35.22-.83.13a1.06,1.06,0,0,1-.29,0,.92.92,0,0,1,.28-.08l.82-.18,1.35-.27a14.92,14.92,0,0,1,1.85-.3,51.71,51.71,0,0,1,11.93,0c5,.5,10.92,1.72,17.45,3,3.27.63,6.72,1.18,10.31,1.58a54.5,54.5,0,0,0,11.14.05,49.43,49.43,0,0,0,10.84-2.55c3.43-1.16,6.7-2.42,9.95-3.24a29.65,29.65,0,0,1,9.44-.95c3,.31,5.69.43,8.21.58a39.08,39.08,0,0,1,6.76.82,21.8,21.8,0,0,0,5.07.49,13.89,13.89,0,0,0,3.18-.49C430.17,435.58,430.53,435.41,430.54,435.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.68,428.47a1.41,1.41,0,0,1-.32.11l-.93.28-.69.21-.86.17-1,.19c-.36.06-.75.09-1.15.14-3.25.43-8,.09-13.74-1-2.87-.52-6-1.17-9.37-1.66a50.23,50.23,0,0,0-10.86-.38c-7.67.48-15.91,2.64-24.8,3.42a67.57,67.57,0,0,1-13-.22c-4.18-.41-8.18-1-12-1.45a97.39,97.39,0,0,0-20.37-.46c-5.8.47-10.46,1.18-13.68,1.64l-3.71.54-1,.13a1.36,1.36,0,0,1-.33,0,1.3,1.3,0,0,1,.33-.08l.95-.18,3.7-.64c3.21-.52,7.87-1.29,13.68-1.8a95.49,95.49,0,0,1,20.46.34c7.64.84,16,2.42,24.89,1.63s17.08-2.92,24.81-3.38a50.3,50.3,0,0,1,10.95.43c3.39.51,6.51,1.19,9.37,1.72,5.71,1.13,10.43,1.53,13.66,1.16.4,0,.78-.07,1.14-.12l1-.17.86-.14.69-.18,1-.23A1.27,1.27,0,0,1,436.68,428.47Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M304.2,425.73a165.45,165.45,0,0,0,26.45,8.63c8.84,2,18.2,2.34,26.84-.35,4.91-1.53,9.52-4,14.56-5,6.09-1.15,12.35,0,18.4,1.32,8,1.71,16.05,3.65,24.15,2.88s18.57-.16,22.08-7.51Z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLateNight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/late-night.29afc9fe71f9ee50310490053bc3e1d2.svg";